import { LocationList } from "../locations/locations";
import { LocationShow } from "../locations/locationShow";

export const OrgLocationsList = (props) => {
  return <LocationList title="My Locations" {...props} />;
};

export const OrgLocationsShow = () => {
  return <LocationShow />;
};
